import { useNavigationRailPortalContext } from './NavigationRailPortalProvider'
import { Box } from '@mui/material'

export default function NavigationRailPortal() {
  const { setPortalNode } = useNavigationRailPortalContext()
  return (
    <Box
      ref={setPortalNode}
      data-portal-id="navigation-rail"
      sx={{ position: 'relative' }}
    />
  )
}
